var map = {
	"./VIP-rewards-tiers.svg": 8152,
	"./VIP-rewards.svg": 48196,
	"./diamond.svg": 42518,
	"./how-it-works.svg": 57415,
	"./ruby.svg": 43086,
	"./sapphire.svg": 93492,
	"./step-four-uk.svg": 24662,
	"./step-four.svg": 48985,
	"./step-one.svg": 48295,
	"./step-three.svg": 24279,
	"./step-two.svg": 14677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82388;